<template>
  <div>
    <span class="character-count" :class="{ 'near-limit': valueLength > maxLength * 0.9 }">
      {{ valueLength }}/{{ maxLength }} characters
    </span>
    <span class="character-limit-warning" v-if="overLimit">
      <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
      Exceeded character limit
    </span>
  </div>
</template>

<style scoped>
.character-count {
  font-size: 0.8rem;
  color: var(--kate-type-success);
  margin: 5px 0 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.character-count.near-limit {
  color: var(--kate-type-danger);
}

.character-limit-warning {
  display: block;
  text-align: right;
}
</style>

<script>

export default {
  props: {
    valueLength: {
      type: [Number, String],
      required: true,
    },
    maxLength: {
      type: [Number, String],
      default: 2048,
    },
  },

  computed: {
    overLimit() {
      if (!this.valueLength) {
        return false;
      }
      return this.valueLength - this.maxLength > 0;
    },
  },
};
</script>
